var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Almoxarifado"}},[_c('AlmoxarifadoTab')],1),_c('b-tab',{attrs:{"title":"Patrimônio"}},[_c('PatrimonioTab')],1),_c('b-tab',{attrs:{"title":"Administrador"}},[_c('AdministradorTab')],1),_c('b-tab',{attrs:{"title":"Unidade Administrativa"}},[_c('UnidadeAdministrativaTab')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }